import { useState, useLayoutEffect, MutableRefObject } from 'react';
import { CommonUtils } from '@zmedia/bm-soccer-ui/utils';

export function usePosition(ref: MutableRefObject<HTMLElement | null>) {
    let [ElementPosition, setElementPosition] = useState({
        top: 0,
        left: 0,
    });

    function handleChangePosition() {
        if (ref && ref.current) {
            const pos = CommonUtils.findPosition(ref.current);
            setElementPosition(pos);
        }
    }

    useLayoutEffect(() => {
        handleChangePosition();
        window.addEventListener('resize', handleChangePosition);

        return () => {
            window.removeEventListener('resize', handleChangePosition);
        };
    }, [ref]);

    return ElementPosition;
}

export default usePosition;
